import React from 'react';
import Card from '@mui/material/Card';
import DtvBox from '@directv-digital/dds.ui.dtv-box';
import Text from '@directv-digital/fusion.atoms.text'
import { CheckIcon } from "@directv-digital/fusion.atoms.icons";
import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import { useLocationHref } from "src/hooks/useLocationHref";

{ /* Generated by Copilot- Start */ }
interface ChipTray {
  pkgName: string;
  price: string | number;
  channelCount: string;
  isSelected: boolean;
  onClick?: () => void;
  disabled?: boolean;
}
{ /* Generated by Copilot- End */ }

const ChipTray = React.memo((props: ChipTray) => {
  const locationHrefUrl = useLocationHref();
  try {
    const { pkgName, price, channelCount, isSelected, disabled } = props;
    const cardBackgroundColor = isSelected ? colorPalette?.blue?.[900] : colorPalette?.neutral_white?.main;
    const textColor = isSelected ? colorPalette?.neutral_white?.main : colorPalette?.blue?.[900];
    return (
      <Card
        aria-checked={isSelected}
        aria-disabled={!!disabled}
        aria-label={`${pkgName?.toLowerCase()}_${isSelected ? 'selected' : 'unselected'}`}
        data-linkdestination={locationHrefUrl}
        data-linkposition="body"
        id={`chip-${pkgName?.toLowerCase().replace(/\s+/g, '-')}`}
        role="checkbox"
        tabIndex={disabled ? -1 : 0}
        sx={{
          minWidth: '190px',
          width: 'auto',
          maxWidth: '250px',
          height: '60px',
          '& svg': {
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          },
          [DtvTheme.breakpoints.between(DtvTheme.breakpoints.values.sm, DtvTheme.breakpoints.values.md)]: {
            minWidth: '175px',
            minHeight: '60px',
            '& svg': {
              width: '24px',
              height: '24px'
            }
          },
          [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
            minWidth: '155px',
            height: '55px',
            '& svg': {
              width: '20px',
              height: '20px'
            }
          },
          padding: 2,
          backgroundColor: cardBackgroundColor,
          color: textColor,
          border: '1px solid #8D8D8D',
          borderRadius: '8px',
          boxShadow: 'none',
          display: 'flex',
          alignItems: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
          "&:hover": disabled ? {} : {
            backgroundColor: isSelected ? '#102641 !important' : '#10264114 !important'
          },
          "&:focus-visible": disabled ? {} : {
            outline: `4px solid transparent !important`,
            outlineColor: '#3885e1 !important',
            outlineOffset: '0px',
            backgroundColor: isSelected ? '#102641' : colorPalette?.neutral_white?.main
          }
        }}
        onClick={disabled ? undefined : props?.onClick}
      >
        {/* Checkmark Icon */}
        {/* Generated by Copilot- Start */}
        {isSelected && (
          <CheckIcon fill={textColor} />
        )}
        {/* Generated by Copilot- End */}
        {/* Content Area */}
        <DtvBox sx={{
          width: '100%'
        }}>
          <Text variant="body1" sx={{
            fontSize: '16px !important',
            overflowWrap: 'break-word',
            [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
              fontSize: '14px !important'
            }
          }}>
            {pkgName}
          </Text>
          <DtvBox sx={{
            display: 'flex',
justifyContent: 'space-between',
alignItems: 'center',
            width: '100%'
          }}>
          {(price !== null && price !== undefined && price !== '') && (
            <Text variant="body1" sx={{
              fontSize: '16px !important',
              [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                fontSize: '14px !important'
              }
            }}>
              ${price}
            </Text>
            )}
            {channelCount && (
            <Text variant="body1" sx={{
              fontSize: '16px !important',
              [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
                fontSize: '14px !important'
              }
            }}>
              {channelCount}+ ch.
            </Text>
            )}
          </DtvBox>
        </DtvBox>
      </Card>
    );
  } catch (error) {
    console.error("Error in CustomerAcqCompareTool - ChipTray component >> ", error);
    return <ErrorDisplay component="ChipTray" error={error} />;
  }
});

export default ChipTray;
